import { AvForm } from "availity-reactstrap-validation"
import { CustomDatePicker, CustomSelect } from "components/Common"
import CustomSearchBar from "components/Common/CustomTable/SearchBar"
import { parameterCode } from "constant"
import { getCodesByParameterId } from "helpers/app-backend"
import { convertDateFormat, getI18nextLng } from "helpers/utilities"
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
const HeaderButtons = forwardRef(
    ({
        t,
        onSubmit,
    }, ref) => {
        let lang = getI18nextLng()
        const [searchText, setSearchText] = useState('')
        const [serviceTypes, setServiceTypes] = useState([])
        const [serviceType, setServiceType] = useState('')
        const [dates, setDates] = useState([convertDateFormat(new Date(), "YYYY-MM-DD"), convertDateFormat(new Date(), "YYYY-MM-DD")])
        useEffect(() => {
            getServiceType()
        }, [])
        useImperativeHandle(ref, () => ({
            GetDataFilter: () => {
                return getData()
            },
        }));
        const getServiceType = async () => {
            const query = { lang }
            let res = await getCodesByParameterId(parameterCode.SERVICE_TYPE, query);
            res?.map(_item => {
                _item.value = _item.code
                _item.label = `${_item.message}`
                return _item
            });
            res = res || []
            // res.unshift({
            //     value: '',
            //     label: t("ServiceType")
            // })
            setServiceTypes(res)
        }
        const getData = (isClear = false) => {
            return {
                start: convertDateFormat(dates[0] || new Date(), "YYYY-MM-DD"),
                end: convertDateFormat(dates[1] || new Date(), "YYYY-MM-DD"),
                serviceType: serviceType,
                search: isClear ? '' : searchText
            }
        }

        useEffect(() => {
            onSubmit && onSubmit(getData())
        }, [serviceType, dates])


        return (
            <React.Fragment>
                <AvForm>
                    <div className="right-pane-result-detail row" style={{ paddingTop: '10px' }}>
                        <div className="col-12 mb-2">
                            <CustomSearchBar
                                onSearch={(e) => {
                                    setSearchText(e.target.value)
                                }}
                                searchText={searchText}
                                placeholder={t("resultPage:Search Results")}
                                onClear={() => {
                                    setSearchText('')
                                    onSubmit && onSubmit(getData(true))
                                }}
                                onSubmit={(e) => {
                                    e.preventDefault()
                                    onSubmit && onSubmit(getData())
                                }}
                                autoComplete="off"
                            />
                        </div>
                        <div className="col-12 d-flex">
                            <div className="mb-2 flex-1" style={{ marginRight: '2px' }}>
                                <CustomDatePicker
                                    name="requestDate"
                                    label={''}
                                    format={"DD/MM/YYYY"}
                                    dateFormat={"d-m-Y"}
                                    value={[convertDateFormat(dates[0], "DD-MM-YYYY"), convertDateFormat(dates[1], "DD-MM-YYYY")]}
                                    onChangeHandler={(date) => {
                                        if (date.time.length == 2) {
                                            setDates([convertDateFormat(date.time[0], "YYYY-MM-DD"), convertDateFormat(date.time[1], "YYYY-MM-DD")])
                                        }
                                    }}
                                    closeOnSelect={true}
                                    mode='range'
                                    maxDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    conjunction={'  '}
                                />
                            </div>
                            <div className="mb-2 flex-1" style={{ marginLeft: '2px' }}>
                                <CustomSelect
                                    name="machineId"
                                    options={serviceTypes || []}
                                    label={""}
                                    onChange={(e, vals) => {
                                        setServiceType(vals[0] || '')
                                        // setTimeout(() => {
                                        //     onSubmit && onSubmit(getData())
                                        // }, 100);
                                    }}
                                    placeholder={t("ServiceType")}
                                    value={serviceType}
                                />
                            </div>
                        </div>
                    </div>
                </AvForm>
            </React.Fragment>
        )
    })

const mapStateToProps = ({ }) => ({
})

const mapDispatchToProps = dispatch => ({
})
HeaderButtons.displayName = 'HeaderButtons';
export default withTranslation(["common", "resultPage"], { withRef: true })(connect(
    mapStateToProps,
    mapDispatchToProps, null, { forwardRef: true }
)(HeaderButtons))